/* global window */

// Trailing debounce. The returned function exposes `flush()` to run any pending
// call immediately (e.g. before unmount, so a queued write is not lost) and
// `cancel()` to drop it. `flush()` returns the callback's return value.
export const debounce = (callback, wait) => {
  let timeoutId = null;
  let pendingArgs = null;

  const debounced = (...args) => {
    pendingArgs = args;
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      timeoutId = null;
      const args = pendingArgs;
      pendingArgs = null;
      callback(...args);
    }, wait);
  };

  debounced.flush = () => {
    if (timeoutId === null) return undefined;
    window.clearTimeout(timeoutId);
    timeoutId = null;
    const args = pendingArgs ?? [];
    pendingArgs = null;
    return callback(...args);
  };

  debounced.cancel = () => {
    window.clearTimeout(timeoutId);
    timeoutId = null;
    pendingArgs = null;
  };

  return debounced;
};
